import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { socialProjectExportColumns } from '../../config/exportColumns/socialProjectExportColumns'
import { appGetAllProject } from '../../store/socialproject'

function SocialProject() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Social Project</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllProject({
										...params,
										...exportFilters,
										sanstha: sansthaId || permissionOfSanstha,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={socialProjectExportColumns}
							fileName="Social_Projects"
							sheetName="Social Project List"
							buttonText="Export Projects"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/social-project/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Social Project
						</button>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default SocialProject
